import PropTypes from 'prop-types'

const NavigationButtons = ({ currentStep, totalSteps, onPrevious, onNext, isLoading = false, canProgress = true, disabledReason }) => {
  return (
    <>
      {currentStep > 1 && (
        <button
          onClick={onPrevious}
          disabled={isLoading}
          className="absolute left-0 px-spacing-2 py-spacing-1 text-secondary bg-bg-panel border border-border-default rounded-lg hover:text-primary transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          aria-label="Go to previous step"
        >
          Previous
        </button>
      )}

      {currentStep !== totalSteps && (
        <div className="absolute right-0 group">
          <button
            onClick={onNext}
            disabled={isLoading || !canProgress}
            className="px-spacing-2 py-spacing-1 bg-accent text-primary rounded-lg hover:bg-hover transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            aria-label={currentStep === totalSteps ? 'Complete onboarding' : 'Go to next step'}
          >
            {isLoading ? (
              <span className="flex items-center gap-2">
                <svg className="animate-spin w-4 h-4" viewBox="0 0 24 24">
                  <circle 
                    className="opacity-25" 
                    cx="12" 
                    cy="12" 
                    r="10" 
                    stroke="currentColor" 
                    strokeWidth="4"
                    fill="none"
                  />
                  <path 
                    className="opacity-75" 
                    fill="currentColor" 
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  />
                </svg>
                Loading...
              </span>
            ) : (
              currentStep === totalSteps ? 'Complete' : 'Next'
            )}
          </button>
          {disabledReason && (isLoading || !canProgress) && (
            <div className="absolute right-0 bottom-full mb-spacing-2 w-48 p-spacing-2 bg-bg-tooltip text-[12px] text-secondary rounded-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10 border border-border-default text-center">
              {disabledReason}
            </div>
          )}
        </div>
      )}
    </>
  )
}

NavigationButtons.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  onPrevious: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  canProgress: PropTypes.bool,
  disabledReason: PropTypes.string
}


export default NavigationButtons
